export class InheritanceOperation {
    targetTemplate: string = '';
    contextPath: string[] = [];
    inheritKey: string = '';
    sourceTemplate: string = '';
    defaultValue: string = '';
    resolvedValue: string = '';
    wasInherited: boolean = false;

    constructor(params: { targetTemplate?: string; contextPath?: string[]; inheritKey?: string; sourceTemplate?: string; defaultValue?: string; resolvedValue?: string; wasInherited?: boolean } = {}) {
        this.targetTemplate = params.targetTemplate || '';
        this.contextPath = params.contextPath || [];
        this.inheritKey = params.inheritKey || '';
        this.sourceTemplate = params.sourceTemplate || '';
        this.defaultValue = params.defaultValue || '';
        this.resolvedValue = params.resolvedValue || '';
        this.wasInherited = params.wasInherited || false;
    }
}
